// スタイルシートを読み込む
import "./scss/_reset.scss";
import "./scss/common.scss";

import jQuery from "jquery";
import ScrollMagic from "scrollmagic";

const $ = jQuery;

$(window).on('load', function(){
	var tags = '.fadein, .fadein > li, section, .fadein > a, h1, h2, h3, h4, h5, h6, p, figure, .note, time, dt, dd, nav, .wp-pagenavi, table';
	$(tags).not('.no-fadein').css('opacity', 0);
	var controller = new ScrollMagic.Controller();
	$(tags).not('.no-fadein').each(function (i, node) {
        var scene = new ScrollMagic.Scene({
            triggerElement: node,
            triggerHook: "onEnter",
            reverse: false,
        })
            .setClassToggle(node, "motion")
            .addTo(controller);
    });

		$('body').fadeIn();
		$("#loading").fadeOut(500);
		

});

/*********************
* youtube
**********************/

var tag = document.createElement('script'),
	firstScriptTag = document.getElementsByTagName('script')[0],
	player,
	ytid = $('#player-wrap').data('yt'),
	w = $(window).width();

tag.src = "https://www.youtube.com/iframe_api";
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

if(w > 756){
    var video_w = 1280;
    var video_h = 720;
} else {
    var video_w = 853;
    var video_h = 480;
}

function onYouTubeIframeAPIReady() {
	window.YT.ready(function() {
		player = new YT.Player('player', {
			height: video_h,
			width: video_w,
			videoId: 'oWJY3et5RpU',
			playerVars: {
				'autoplay': 0,
				'controls': 1,
				'rel': 0,
				'ref': 0,
				'loop': 1,
				'modestbranding': 1,
				'showinfo': 0,
				'autohide': 2,
				'theme': 'light',
				'color': 'white',
				'wmode' : 'transparent'
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		});
	});
}

function onPlayerReady( event ) {
}

function onPlayerStateChange(event) {
	if (event.data == YT.PlayerState.ENDED) {
		$('#player-wrap img').show();
	}
}
function myPlayVideo() {
	player.playVideo();
}

//動画サイズの調整
function playerSize() {
	var w = $(window).width(), 
		player_w = (w > 1023) ? w - 90 : w,
		player_h = player_w * 0.5625,
		player_l = (w > 1023) ? player_w / 2 : 0,
		player_t = (w > 1023) ? player_h / 2 : 0;

	$('#player-wrap, #player, #top-photo').width(player_w);
	$('#player-wrap, #player, #top-photo').height(player_h);
	$('#player, #top-photo').css({'margin-left': '-' + player_l + 'px' });
	$('#player, #top-photo').css({'margin-top': '-' + player_t + 'px' });
}

$(function () {
	if($('body').hasClass('home')){
		onYouTubeIframeAPIReady();
	}

	var w = $(window).width(),
		h = $(window).height(),
		secTopArr = new Array(),
		navLinkArr = new Array(),
		moveFlug = false,
		allHeight = $('body').outerHeight(true),
		current = -1,
		agent = navigator.userAgent,
		ytid = $('#player-wrap').data('yt');

	//動画サイズ
	playerSize();

	//NEWS 
	var news_paged = 1;
	if($('.info-list').data('paged') !== 0){
		news_paged = parseInt($('.info-list').data('paged'));
	}
	var get_news_num = 6;
	var now_news_num = 6 * news_paged;
	$(document).on('click', '.more-news-btn', function() {
		$('.more-news-btn').remove();
		$('.info-list').append('<div class="more-loader black"><span></span></div>');
		$.ajax({
			type: 'post',
			url: SiteThemeURL + '/news-more.php',
			data: {
					'now_post_num': now_news_num,
					'get_post_num': get_news_num,
				},
			success: function(data) {
					now_news_num = now_news_num + get_news_num;
					data = JSON.parse(data);
					$('.more-loader').remove();
					$('.info-list').append(data['html']);
					if (!data['noDataFlg']) {
							$('.info-list').append('<p class="more-news-btn"><span>MORE</span></p>');
					}
			}
		});
		return false;
	});

	//WORKS
	$('.works-nav-wrap').on('click', function(){
		var post_id = $(this).data('postid');
		$.ajax({
				url: SiteThemeURL + '/work.php',
        data: {
					'post_id': post_id
        },
        success: function(data) {
					$('#works-modal-cnt').html('');
					$('#works-modal-cnt').append('<span id="works-modal-close"></span>');
					 $('#works-modal-cnt').append(data);
					 $('#works-modal').fadeIn(300);

					 $('#works-modal-close, .works-modal-close, .modal-bg').on('click', function(){
							$('#works-modal').fadeOut(100);
							$('#works-modal-inner').scrollTop(0);
					 });
				}
			}
		);
	});

	//WORKS MORE
	var get_works_num = 12;
	var now_works_num = 12;
	var works_genre = $('.works-nav').data('genre');
	$(document).on('click', '.more-works-btn', function() {
		$('.more-works-btn').remove();
		$('.works-nav').append('<div class="more-loader"><span></span></div>');
		$.ajax({
			type: 'post',
			url: SiteThemeURL + '/works-more.php',
			data: {
					'now_post_num': now_works_num,
					'get_post_num': get_works_num,
					'genre': works_genre,
				},
				success: function(data) {
					now_works_num = now_works_num + get_works_num;
					data = JSON.parse(data);
					$('.more-loader').remove();
					$('.works-nav').append(data['html']);
					if (!data['noDataFlg']) {
							$('.works-nav').append('<p class="more-works-btn"><span>MORE</span></p>');
					}

					$('.works-nav-wrap').on('click', function(){
						var post_ajax_id = $(this).data('postid');
						$.ajax({
								url: SiteThemeURL + '/work.php',
								data: {
									'post_id': post_ajax_id
								},
								success: function(data) {
									$('#works-modal-cnt').html('');
									$('#works-modal-cnt').append('<span id="works-modal-close"></span>');
									 $('#works-modal-cnt').append(data);
									 $('#works-modal').fadeIn(300);
				
									 $('#works-modal-close, .works-modal-close, .modal-bg').on('click', function(){
											$('#works-modal').fadeOut(100);
											$('#works-modal-inner').scrollTop(0);
									 });
								}
							}
						);
					});
				
			}
		});
		return false;
	});


	//ALBUMS
	$('.albums-nav-wrap').on('click', function(){
		var post_id = $(this).data('postid');
		$.ajax({
				url: SiteThemeURL + '/album.php',
        data: {
					'post_id': post_id
        },
        success: function(data) {
					$('#albums-modal-cnt').html('');
					$('#albums-modal-cnt').append('<span id="albums-modal-close"></span>');
					 $('#albums-modal-cnt').append(data);
					 $('#albums-modal').fadeIn(300);

					 $('#albums-modal-close, .albums-modal-close, .modal-bg').on('click', function(){
							$('#albums-modal').fadeOut(100);
							$('#albums-modal-inner').scrollTop(0);
					 });
				}
			}
		);

	});

	//INFO
	$('.info-list > li > .more').on('click', function(){
		$(this).toggleClass('active').next('.more-cnt').slideToggle();
	});

	//sectionの高さ
	//$('section').css('min-height', h);

	//スマホ＆タブレットの場合はポップアップで動画表示
	if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/Android/) != -1){
		$('#player-wrap, #top-play').on('click', function () {
			$('#grayLayer, #sp-player').fadeIn();
			$('#sp-player').append('<iframe  width="853" height="480" src="https://www.youtube.com/embed/' + ytid + '?autoplay=0&ref=0&rel=0" frameborder="0" allowfullscreen></iframe>');
			$('#sp-player, #sp-player .close').fadeIn(300);
			//閉じるとき
			$('#grayLayer, .close').on('click', function () {
				$('#sp-player, #sp-player .close').fadeOut('fast');
				$('#sp-player').find('iframe').remove();
				$('#grayLayer').fadeOut();
			});
		});

    //PCの場合は埋め込みで動画表示
    } else {
		$('#player-wrap, #movie-controller .play-btn').on('click', function () {
			$('#player-wrap img').fadeOut();
			myPlayVideo();
		});
	}

	//WORKSのインデックスを取得
	var searchSecWorks = [];

	$('section').each(function (i) {
		searchSecWorks[i] = $(this).attr('id');
	});

	//各sectionの位置を取得
	$('section').each(function (i) {
			secTopArr[i] = $(this).offset().top;
	});

	$('.nav-link').each(function (i) {
		navLinkArr[i] = $(this).attr('id');
	});

	//初期背景の追加
	if(!$('body').hasClass('home')){
		$('#wrap').append('<div id="bg0"></div>');
	}

	/**** SP MENU ****/

	/*
	$('.nav-menu-btn, .sp-nav-menu').on('click', function () {
		$('.sp-nav-menu').fadeToggle();
	});
	*/

	//nav btn
	$('#nav-btn').on('click', function() {
		$('#sp-nav-menu').fadeToggle();
		$("#nav-btn-icon").toggleClass('close');
		$('#sp-nav-menu ul li a').on('click', function() {
			$('#sp-nav-menu').fadeOut();
			$("#nav-btn-icon").removeClass("close");
		});
		return false;
	});


	$(window).on('scroll', function () {

		var scrollTop = $(this).scrollTop(),
			headerHeight = $('header').height();

		//トップページの場合
		if($('body').data('page') == 'top') {

			//タイトルロゴの表示
			if(scrollTop > 150) {
				$('.nav-name').fadeIn(200);
			} else if(scrollTop < 150) {
				$('.nav-name').fadeOut(200);
			}

			if(scrollTop > headerHeight) {
				$('#main-nav').css('position','fixed');
				$('header').css('margin-bottom','64px');
			} else if(scrollTop < headerHeight) {
				$('#main-nav').css('position','relative');
				$('header').css('margin-bottom','0');
			}

			if($(window).width() > 1023){
				for (var i = secTopArr.length-1; i>=0; i--) {
					if(i == 0) {
						if ($(window).scrollTop() > 0) {
							chengeBG(i);
							break;
						}
					} else {
						if ($(window).scrollTop() > secTopArr[i] -200) {
							chengeBG(i);
							break;
						}
					}
				}
			}
		}
	});

	function chengeBG(secNum) {

		if($(window).width() > 768){
			if (secNum != current) {
				//ナビゲーションの色を変える
				$('#'+navLinkArr[current]).animate({backgroundColor: '#ffffff', color: '#000000'}, 200);
				$('#'+navLinkArr[secNum]).animate({backgroundColor: '#000000', color: '#ffffff'}, 200);
				$('#bg'+current).fadeOut(1000, function(){
					$(this).remove();
				});
				$('#wrap').append('<div id="bg'+secNum+'"></div>');
				$('#bg'+secNum).height($(window).height()).css('display','none').fadeIn(1000);
				//背景画像に合わせて見出しの文字色を変化
				if(searchSecWorks[secNum] == 'profile' || searchSecWorks[secNum] == 'info') {
					$('h1').animate({color: '#000000'}, 200);
					$('section').addClass('black');
				} else {
					$('h1').animate({color: '#ffffff'}, 200);
					$('section').removeClass('black');
				}
				current = secNum;
			}
			$('#bg' + secNum).css('background-size', 'cover');
			$('#bg' + secNum).css('background-position', 'center');
		}
	}


	/*******************
	* #で始まるアンカーをクリックした場合にスクロール
	********************/

	$('a[href^="#"]').on('click', function () {
		var speed = 400,
		easing = "swing",
		href = $(this).attr("href"),
		target = $(href == "#" || href == "" ? 'html' : href),
		position = target.offset().top - 64;
		$('body,html').animate({scrollTop: position}, speed, easing);
		return false;
	});


 	/*******************
	* contact
	********************/

	var contactWorks = $('#contact-works').height() + 50,
		contactAlbums = $('#contact-albums').height() + 50;

	if (contactWorks > contactAlbums) {
		$('#contact-albums').css('height', contactWorks);
	} else {
		$('#contact-works').css('height', contactAlbums);
	}



	/*********************
	* トップページでない場合の処理
	**********************/
	if($('body').data('page') != 'top') {
		$('.nav-name').css('display', 'inline');
		$('#main-nav').css('position','fixed');
		$('header').css('margin-bottom','64px');
	}

//google analytics
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
  ga('create', 'UA-58928692-1', 'auto');
  ga('send', 'pageview');

});

$(window).on('load resize', function() {
	playerSize();
	if($(window).width() > 1023){
		$('#bg0').css('background-size', 'cover');
		$('#bg0, #bg1, #bg2, #bg3, #bg4').height($(window).height());
	}

	//MW WP Form エラーの場合
	if($('.mailform dd span').hasClass('error') || $('.mw_wp_form').hasClass('mw_wp_form_confirm') || $('.mw_wp_form').hasClass('mw_wp_form_complete')){
		var errorPos = $('#contact').offset().top - 64;
		$("html, body").animate({scrollTop:errorPos}, 0);
	}

	if($('.mw_wp_form').hasClass('mw_wp_form_confirm')){
		$('.mw_wp_form input[name=_wp_http_referer]').val(document.referrer + '?id=contact');
	}
	

	var anchorFlg = true;
	if(anchorFlg === true) {
		var url = $(location).attr('href');
		if(url.indexOf("?sid=") != -1){
			var id = url.split("?sid=");
			var t_target = $('#' + id[id.length - 1]);
			if(t_target.length){
					var pos = t_target.offset().top - 64;
					$("html, body").animate({scrollTop:pos}, 0);
			}
		}
		anchorFlg = false;
	}

});
